module.exports = __webpack_public_path__ + "img/TuneIn_Logo_2018.a8fd790a.svg";